import { EVENT_TYPES } from 'consts';
import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine} from "recharts";
import { unitsConvert } from 'utils/formaters';
import { timeFormatter } from 'utils/formaters';
import { SpotCheckLabel } from '../Labels';

export default function SpotCheckChart({data,dataKey,name,unit,xTicks,xLines,height,showX}) {
   const renderLegend = (props) => {
        const { payload } = props;
        const {value, color} = payload[0]
        return (
            <div style={{color}} > 
                <div> {value} </div>
                <small> {unit} </small>
            </div>
        )
    }

    const defaultUnits = () => {
        switch(dataKey){
            case EVENT_TYPES.BODY_TEMP:
                return '°C'
            case EVENT_TYPES.GLUCOSE:
                return 'mg/dL'
            default:
                return null
        }
    }
    const getSign = () => {
        switch(dataKey){
            case EVENT_TYPES.BODY_TEMP:
                return '°'
            case EVENT_TYPES.GLUCOSE:
                return '‎'
            default:
                return null
        }
    }
    const convertData = () => {
        const defaultUnit = defaultUnits();
        const addSign = getSign()
        const toConvert = unit !== defaultUnit;
        const convert = unitsConvert(unit)
        if(dataKey !== EVENT_TYPES.GLUCOSE && dataKey !== EVENT_TYPES.BODY_TEMP) return data
        return data.filter(df => df[dataKey]).map(dm => ({...dm, [dataKey]: `${toConvert ? convert(dm[dataKey]) : dm[dataKey]}${addSign}`}))
    }

    return (
        <ResponsiveContainer width="100%" height={height} >
            <LineChart data={convertData()} margin={{ right: 30, left: 150}}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                    hide={!showX} 
                    ticks={xTicks} 
                    domain={[xTicks[0],xTicks[12]]} 
                    tickFormatter={timeFormatter} 
                    type="number" 
                    dataKey="time" /> 
                <YAxis type="number" />
                <ReferenceLine 
                    x={"00:00"} 
                    stroke="#636E72"/>
                <Tooltip 
                    cursor={false} 
                    labelFormatter={time=>timeFormatter(time)}/>
                <Legend 
                    layout="vetical" 
                    verticalAlign="middle" 
                    content={renderLegend}
                    wrapperStyle={Object.assign({position: 'absolute', left:0 },showX&&{top:10}) }/>
                {xLines.map(time=>
                <ReferenceLine 
                    key={time} 
                    x={time} 
                    stroke="#636E72"/>)}
                <Line 
                    isAnimationActive={false}
                    type="monotone"
                    name={name} 
                    dataKey={dataKey} 
                    dot={false} 
                    activeDot={false}  
                    stroke="black"
                    label={<SpotCheckLabel/>} />
                {/* <Brush dataKey="time" height={30} stroke="#8884d8" /> */}
            </LineChart>
        </ResponsiveContainer>
    )
}
